export const USER_QUERY_KEY = ['user'] as const;
export const STUDENT_JOIN_OFFERS_QUERY_KEY = ['student-join-offers'] as const;
export const USER_PROFILES_QUERY_KEY = ['user-profiles'] as const;
export const USER_UNSEEN_EVENTS_QUERY_KEY = ['user-unseen-events'] as const;
export const NEWS_QUERY_KEY = ['news'] as const;
export const GALLERY_QUERY_KEY = ['gallery'] as const;
export const NOTICE_QUERY_KEY = ['notice'] as const;
export const TEACHER_MESSAGES_QUERY_KEY = ['teacher-messages'] as const;
export const EVALUATIONS_SUMMARY_QUERY_KEY = ['evaluations-summary'] as const;
export const EVALUATION_QUERY_KEY = ['evaluation'] as const;
export const TEST_REPORT_QUERY_KEY = ['test-report'] as const;
export const LESSON_TYPES_QUERY_KEY = ['lesson-types'] as const;
export const STUDY_YEAR_PERIODS_QUERY_KEY = ['study-year-periods'] as const;
export const EVALUATION_RATINGS_QUERY_KEY = ['evaluation-ratings'] as const;
export const SAME_LEVEL_CLASSES_QUERY_KEY = ['same-level-classes'] as const;
export const NON_ATTENDANCE_APPLICATIONS_QUERY_KEY = [
  'non-attendance-applications',
] as const;
export const NON_ATTENDANCE_APPLICATIONS_PROPERTIES_QUERY_KEY = [
  'non-attendance-applications-properties',
] as const;
export const NON_ATTENDANCE_APPLICATION_QUERY_KEY = [
  'non-attendance-application',
] as const;
export const PAYMENT_OPTIONS_QUERY_KEY = ['payment-options'] as const;
export const NOTIFICATION_SETTINGS_QUERY_KEY = [
  'notification-settings',
] as const;
export const TEST_SCHEDULES_QUERY_KEY = ['test-schedules'] as const;
export const LESSON_TIMES_QUERY_KEY = ['lesson-times'] as const;
export const LINKS_QUERY_KEY = ['links'] as const;
export const MAIL_FOLDERS_QUERY_KEY = ['mail-folders'] as const;
export const MAIL_MESSAGE_IDS_QUERY_KEY = ['mail-message-ids'] as const;
export const MAIL_MESSAGES_QUERY_KEY = ['mail-messages'] as const;
export const MAIL_MESSAGE_QUERY_KEY = ['mail-message'] as const;
export const MAIL_MESSAGE_RECIPIENTS_QUERY_KEY = [
  'mail-message-recipients',
] as const;
export const MAIL_RECIPIENT_GROUPS_QUERY_KEY = [
  'mail-recipient-groups',
] as const;
export const MAIL_RECIPIENT_GROUP_MEMBERS_QUERY_KEY = [
  'mail-recipient-group-members',
] as const;
export const SURVEYS_QUERY_KEY = ['surveys'] as const;
export const SURVEY_QUERY_KEY = ['survey'] as const;
export const SURVEY_RESULTS_QUERY_KEY = ['survey-results'] as const;
export const SURVEY_QUESTION_QUERY_KEY = ['survey-question'] as const;
export const VIDEO_MEETINGS_QUERY_KEY = ['video-meetings'] as const;
export const VIDEO_MEETING_QUERY_KEY = ['video-meeting'] as const;
export const ATTACHMENT_QUERY_KEY = ['attachment'] as const;
export const FAMILY_SETTINGS_QUERY_KEY = ['family-settings'] as const;
export const PRESCHOOL_EVALUATION_QUERY_KEY = ['preschool-evaluation'] as const;
export const DIARY_QUERY_KEY = ['diary'] as const;
export const HOME_TASK_QUERY_KEY = ['home-task'] as const;
export const HOME_TASKS_QUERY_KEY = ['home-tasks'] as const;
export const THIRD_PARTY_EVENTS_QUERY_KEY = ['third-party-events'] as const;
export const PRESCHOOL_EDUCATION_PLANS_QUERY_KEY = [
  'preschool-education-plans',
] as const;
export const JOURNALS_QUERY_KEY = ['journals'] as const;
export const JOURNAL_REPORTS_QUERY_KEY = ['journal-reports'] as const;
